import { initializeTable } from '../tables';
import { sendGetRequest, sendPostRequest } from '../../utils';
import { addAlert, addLocalStorageAlert } from '../../alerts';
import { prompt, loaderPrompt } from '../../prompts';
import Swal from 'sweetalert2';

const ENOVA_DICT_COLUMNS = [
    { title: '#', field: 'id', width: 60, resizable: false },
    { title: gettext('Wartość'), field: 'value', resizable: false },
    { title: 'GUID', field: 'guid', resizable: false },
    {
        title: gettext('Aktywny'),
        field: 'is_active',
        resizable: false,
        width: 120,
        formatter: (cell) => {
            const val = cell.getValue();
            return val ? gettext('Tak') : gettext('Nie');
        },
    },
];

const WAREHOUSE_COLUMNS = [
    { title: '#', field: 'id', width: 60, resizable: false },
    { title: gettext('Nazwa'), field: 'name', resizable: false },
    { title: gettext('Kod'), field: 'code', resizable: false, width: 150 },
];

const WORKSTATION_COLUMNS = [
    { title: '#', field: 'id', width: 60, resizable: false },
    {
        title: gettext('Kod stanowiska'),
        field: 'station_code',
        resizable: false,
        width: 160,
    },
    {
        title: gettext('Typ stanowiska'),
        field: 'station_type',
        resizable: false,
    },
    {
        title: gettext('Adres IP'),
        field: 'ip_address',
        resizable: false,
        width: 140,
    },
    {
        title: gettext('Enova ID'),
        field: 'remote_id',
        resizable: false,
        width: 110,
    },
    { title: gettext('Enova GID'), field: 'remote_gid', resizable: false },
];

function getColumnsForTab(tabKey) {
    if (tabKey === 'Warehouse') return WAREHOUSE_COLUMNS;
    if (tabKey === 'WorkStation') return WORKSTATION_COLUMNS;
    return ENOVA_DICT_COLUMNS;
}

function buildAjaxUrl(tabKey) {
    return `/api/dictionaries/data/${encodeURIComponent(tabKey)}/`;
}

let currentTable = null;

function loadTab(tabKey) {
    const tableElement = document.querySelector('#dictionariesTable');
    if (!tableElement) return;

    if (currentTable) {
        currentTable.destroy();
        currentTable = null;
    }
    tableElement.innerHTML = '';

    const columns = getColumnsForTab(tabKey);

    currentTable = initializeTable({
        tableElement,
        ajaxURL: buildAjaxUrl(tabKey),
        columns,
        handleFiltering: false,
    });
}

// --- Sync helpers ---

const pollJobStatus = async (jobId) => {
    try {
        const response = await sendGetRequest(`/api/utils/job-status/${jobId}`);
        const data = await response.json();

        if (data.status === 'finished') {
            addLocalStorageAlert(
                'success',
                gettext('Synchronizacja zakończona pomyślnie.'),
            );
            window.location.reload();
        } else if (data.status === 'failed') {
            Swal.close();
            addAlert('error', gettext('Synchronizacja zakończyła się błędem.'));
        } else {
            setTimeout(() => pollJobStatus(jobId), 2000);
        }
    } catch (error) {
        Swal.close();
        addAlert(
            'error',
            error.response?.data?.message ||
                gettext('Błąd podczas sprawdzania statusu zadania.'),
        );
        console.error('Error polling job status', error);
    }
};

const handleDictionarySync = async () => {
    await prompt({
        title: gettext('Potwierdź synchronizację'),
        text: gettext(
            'Czy na pewno chcesz zsynchronizować słowniki, magazyny i stanowiska z Enova?',
        ),
        confirmText: gettext('Synchronizuj'),
        confirmAction: async () => {
            loaderPrompt(gettext('Trwa synchronizacja...'));
            try {
                const response = await sendPostRequest(
                    '/api/utils/sync-dictionaries',
                );
                const data = await response.json();
                pollJobStatus(data.job_id);
            } catch (error) {
                Swal.close();
                addAlert(
                    'error',
                    error.response?.data?.message ||
                        gettext('Nie udało się rozpocząć synchronizacji.'),
                );
                console.error('Error starting dictionary sync', error);
            }
        },
    });
};

export default function initializeDictionariesTable() {
    const tabsContainer = document.querySelector('#dictionariesTabsList');
    if (!tabsContainer) return;

    const allTabs = tabsContainer.querySelectorAll('.tab');
    const STORAGE_KEY = 'lastActiveDictionaryTab';

    function setActiveTab(tabElement) {
        allTabs.forEach((t) => t.classList.remove('active'));
        tabElement.classList.add('active');
    }

    let savedTabKey = null;
    try {
        savedTabKey = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
        console.warn('localStorage access failed:', e);
    }

    let initialTab =
        tabsContainer.querySelector(`.tab[data-value="${savedTabKey}"]`) ||
        allTabs[0];

    setActiveTab(initialTab);
    loadTab(initialTab.dataset.value);

    allTabs.forEach((tab) => {
        tab.addEventListener('click', function () {
            if (this.classList.contains('active')) return;
            setActiveTab(this);
            const tabKey = this.dataset.value;
            try {
                localStorage.setItem(STORAGE_KEY, tabKey);
            } catch (e) {
                console.warn('localStorage access failed:', e);
            }
            loadTab(tabKey);
        });
    });

    const syncBtn = document.getElementById('syncDictionariesBtn');
    if (syncBtn) {
        syncBtn.addEventListener('click', handleDictionarySync);
    }
}
